<template lang="pug">
  v-slider(hide-details color="secondary" style="padding-top:10px" thumb-label="always" :thumb-size="24" :min="min" :max="max" :step="step"
  :value="simulationParams[type][ind]" @change="updateSetting($event)") <!-- see https://github.com/vuejs/vue/issues/6914-->
</template>

<script>
export default {
  name: "setting-input",
  props: {
    label: { type: String, default: "missing label" },
    type: { type: String, default: "" },
    ind: { type: Number, default: null },
    min: { type: Number, default: null },
    max: { type: Number, default: null },
    step: { type: Number, default: null }
  },
  computed: {
    simulationParams() {
      return this.$store.state.simulationParams;
    },
    simulation() {
      return this.$store.state.simulation.simulation;
    }
  },
  methods: {
    updateSetting: function(newVal) {
      this.$store.state.simulationParams[this.type][this.ind] = newVal;
      this.$store.dispatch("simulation/update", this.simulationParams);
      this.$store.dispatch("chartData/updateData", this.simulation.signals);
    }
  }
};
</script>

<style></style>
